import { Box } from "@mui/material"
import type { SxProps } from "@mui/material"

import { StyledLabel } from "./styles"
import type { ColorTypes } from "./styles"

function Label({
  children,
  color = "default",
  variant = "soft",
  startIcon,
  endIcon,
  sx,
  ...other
}: {
  children: React.ReactNode
  color?: ColorTypes
  variant?: "filled" | "outlined" | "soft"
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  sx?: SxProps
}) {
  const iconStyle = {
    width: 16,
    height: 16,
    "& svg, img": { width: 1, height: 1, objectFit: "cover" },
  }

  return (
    <StyledLabel
      ownerState={{ color, variant }}
      sx={{
        ...(startIcon && { pl: 0.75 }),
        ...(endIcon && { pr: 0.75 }),
        ...sx,
      }}
      {...other}
    >
      {startIcon && <Box sx={{ mr: 0.75, ...iconStyle }}> {startIcon} </Box>}

      {children}

      {endIcon && <Box sx={{ ml: 0.75, ...iconStyle }}> {endIcon} </Box>}
    </StyledLabel>
  )
}

Label.displayName = "Label"

export default Label
